import { DEFAULT_HOTBAR_SLOTS } from '../constants/DefaultHotbars';

/**
 * Peaceful mode grants a transient cross-class movement kit. Those abilities
 * are intentionally usable regardless of the character's ordinary progression
 * curve, but only while the authoritative peaceful flag is active.
 */
export const PEACEFUL_HOTBAR_ABILITY_IDS = Object.freeze(
  (DEFAULT_HOTBAR_SLOTS.peaceful ?? [])
    .map((slot) => slot.abilityId)
    .filter((abilityId): abilityId is string => typeof abilityId === 'string'),
);

const PEACEFUL_HOTBAR_ABILITY_ID_SET = new Set(PEACEFUL_HOTBAR_ABILITY_IDS);

export function isPeacefulHotbarAbility(
  peaceful: boolean | null | undefined,
  abilityId: string,
): boolean {
  return peaceful === true && PEACEFUL_HOTBAR_ABILITY_ID_SET.has(abilityId);
}
